import { useCallback } from 'react';
import { RichEditor } from '@odo/shared-ui';
import { uploadInternalImage } from '../../../../services/internalImages';
import type { TiptapDoc } from './types';
import type { RichEditorPreset } from '@odo/shared-ui';

interface DxRichSectionProps {
    patientId: string;
    value: TiptapDoc;
    onChange: (next: TiptapDoc) => void;
    placeholder?: string;
    chrome?: 'card' | 'flush';
    minHeightPx?: number;
    readOnly?: boolean;
    presets?: RichEditorPreset[];
}

export function DxRichSection({
    patientId,
    value,
    onChange,
    placeholder,
    chrome,
    minHeightPx,
    readOnly,
    presets
}: DxRichSectionProps) {
    const handleImageUpload = useCallback(
        async (file: File) => {
            const result = await uploadInternalImage(patientId, file, 'dx-report');
            return { url: result.url, fileId: result.fileId };
        },
        [patientId]
    );

    return (
        <RichEditor
            value={value}
            onChange={onChange}
            onImageUpload={handleImageUpload}
            placeholder={placeholder}
            chrome={chrome}
            minHeightPx={minHeightPx}
            readOnly={readOnly}
            presets={presets}
            enableImageCaptions
        />
    );
}
